import { useMutation } from "@tanstack/react-query";
import { reopenActivity, ReopenActivityPayload } from "PFCore/services/activities";
import { MutationOptions } from "PFCore/types";

export const useReopenActivity = (options: MutationOptions<ReopenActivityPayload> = {}) =>
  useMutation<void, unknown, ReopenActivityPayload>(
    async (payload: ReopenActivityPayload) => reopenActivity(payload),
    options
  );
